import { useTranslation } from 'react-i18next';
import { VossTimeLengthUnitsShortText } from '../../../Constants/VOSS/vossTimeLengthUnits';
import { VossPeriodOffsetAnchorText } from '../../../Constants/VOSS/vossPlanEnums';
import type { PeriodDateOffset, TimeLength } from './Packages.types';

const usePlanFormat = () => {
    const { t } = useTranslation();

    const formatTimeLength = (length: TimeLength | null | undefined, emptyText = '—'): string =>
        length?.value === undefined || length.unit === undefined ? emptyText : `${length.value} ${t(VossTimeLengthUnitsShortText[length.unit])}`;

    // a cycle without a length never ends in VOSS, so it reads as "no end date" rather than as missing data
    const formatCycleLength = (length: TimeLength | null | undefined): string => formatTimeLength(length, t('packages.evergreen') ?? '');

    const formatOffset = (offset: PeriodDateOffset | null | undefined): string =>
        offset?.periodAnchor === undefined
            ? '—'
            : t('packages.offsetFrom', { length: formatTimeLength(offset.length), anchor: t(VossPeriodOffsetAnchorText[offset.periodAnchor]) });

    return { formatTimeLength, formatCycleLength, formatOffset };
};

export default usePlanFormat;
